<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Ortho Diagnose Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div v-if="this.$route.query.id === undefined" class="form-group col-3">
                <label for="module">Patient Name</label>
                <app-lookup-field :model="patientOrthoDiagnose" :element="patientLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div v-if="this.$route.query.id !== undefined" class="form-group col-3">
                <label>Patient Name</label>
                <input type="text" class="form-control" v-model="patientOrthoDiagnose.patientName" disabled id="patientName" aria-describedby="action">
            </div>
            <div class="form-group col-2">
                <label for="module">Patient Age</label>
                <input type="text" class="form-control" v-model="patientOrthoDiagnose.patientAge" disabled id="patientName" aria-describedby="action">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Patient Address</label>
                <textarea class="form-control" id="desc-textarea" v-model="patientOrthoDiagnose.patientAddress" rows="2" disabled></textarea>
            </div>
        </div>
        <div class="p-2 dropdown-divider" style="border-top: 2px solid black;"></div>
        <br />

        <div class="row">
            <div class="form-group col-2">
                <label>Klasifikasi</label>
            </div>
            <div class="form-group col-4">
                <div class="input-group mb-2 mr-sm-2">
                    <label style="margin-right: 15px;" for="module">Kiri</label>
                    <input type="number" class="form-control" id="clarificationL" v-model="patientOrthoDiagnose.clarificationL">
                </div>
            </div>
            <div class="form-group col-4">
                <div class="input-group mb-2 mr-sm-2">
                    <label style="margin-right: 15px;" for="module">Kanan</label>
                    <input type="number" class="form-control" id="clarificationR" v-model="patientOrthoDiagnose.clarificationR">
                </div>
            </div>
        </div>


        <div class="row">
            <div class="form-group col-2">
                <label>Profil</label>
            </div>
            <div class="form-group col-4">
                <div class="input-group mb-2 mr-sm-2">
                    <input type="number" class="form-control" id="profile" v-model="patientOrthoDiagnose.profile">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-2">
                <label class="lbl">Agnesis</label>
            </div>
            <div class="form-group col-4"> 
                <div class="row">
                    <div class="input-group col-5" style="border-right: 2px solid black; border-bottom: 2px solid black;"> 
                        <div class="form-group">
                            <input type="text" class="form-control" id="agnesisTL" v-model="patientOrthoDiagnose.agnesisTL">
                        </div>
                    </div>
                    <div class="input-group col-5" style="border-bottom: 2px solid black;"> 
                        <div class="form-group">
                            <input type="text" class="form-control" id="agnesisTR" v-model="patientOrthoDiagnose.agnesisTR">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="input-group col-5" style="border-right: 2px solid black;"> 
                        <div class="form-group" style="margin-top: 18px;">
                            <input type="text" class="form-control" id="agnesisBL" v-model="patientOrthoDiagnose.agnesisBL">
                        </div>
                    </div>
                    <div class="input-group col-5" style="margin-top: 18px;"> 
                        <div class="form-group">
                            <input type="text" class="form-control" id="agnesisBR" v-model="patientOrthoDiagnose.agnesisBR">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group col-2">
                <label class="lbl">Impacted/Imbanded</label>
            </div>
            <div class="form-group col-4"> 
                <div class="row">
                    <div class="input-group col-5" style="border-right: 2px solid black; border-bottom: 2px solid black;"> 
                        <div class="form-group">
                            <input type="text" class="form-control" id="impactedTL" v-model="patientOrthoDiagnose.impactedTL">
                        </div>
                    </div>
                    <div class="input-group col-5" style="border-bottom: 2px solid black;"> 
                        <div class="form-group">
                            <input type="text" class="form-control" id="impactedTR" v-model="patientOrthoDiagnose.impactedTR">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="input-group col-5" style="border-right: 2px solid black;"> 
                        <div class="form-group" style="margin-top: 18px;">
                            <input type="text" class="form-control" id="impactedBL" v-model="patientOrthoDiagnose.impactedBL">
                        </div>
                    </div>
                    <div class="input-group col-5" style="margin-top: 18px;"> 
                        <div class="form-group">
                            <input type="text" class="form-control" id="impactedBR" v-model="patientOrthoDiagnose.impactedBR">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="form-group col-2">
                <label class="lbl">Keluhan</label>
            </div>
            <div class="form-group col-4"> 
                <div class="form-group col-12">
                    <textarea class="form-control" rows="5" id="complaint" v-model="patientOrthoDiagnose.complaint"></textarea>
                </div>
            </div>
            <div class="form-group col-2">
                <label class="lbl">Missing</label>
            </div>
            <div class="form-group col-4"> 
                <div class="row">
                    <div class="input-group col-5" style="border-right: 2px solid black; border-bottom: 2px solid black;"> 
                        <div class="form-group" style="margin-top: 18px;">
                            <input type="text" class="form-control" id="missingTL" v-model="patientOrthoDiagnose.missingTL">
                        </div>
                    </div>
                    <div class="input-group col-5" style="border-bottom: 2px solid black;"> 
                        <div class="form-group" style="margin-top: 18px;">
                            <input type="text" class="form-control" id="missingTR" v-model="patientOrthoDiagnose.missingTR">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="input-group col-5" style="border-right: 2px solid black;"> 
                        <div class="form-group" style="margin-top: 18px;">
                            <input type="text" class="form-control" id="missingBL" v-model="patientOrthoDiagnose.missingBL">
                        </div>
                    </div>
                    <div class="input-group col-5" style="margin-top: 18px;"> 
                        <div class="form-group">
                            <input type="text" class="form-control" id="missingBR" v-model="patientOrthoDiagnose.missingBR">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-2">
                <label class="lbl">Kelainan</label>
            </div>
            <div class="form-group col-4"> 
                <div class="form-group col-12">
                    <textarea class="form-control" id="abnormalities" v-model="patientOrthoDiagnose.abnormalities" rows="5"></textarea>
                </div>
            </div>
        </div>

        <br /><br />

        <!-- <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="mm.mailManagementDetail"></app-datatable> -->
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel"  style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { PatientOrthoDiagnose } from '../../models/patientOrthoDiagnose'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            patientOrthoDiagnose: {
                ...PatientOrthoDiagnose
            },
            patientLookup: {
                id: 'patient',
                title: 'Patient',
                type: 'form',
                apiUrl: 'patient-list',
                filter: ['name', 'address'],
                fields: [
                    {
                        placeholder: 'Patient',
                        width: 12,
                        column: 'patientName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Patient Name',
                        column: 'name'
                    },
                    {
                        title: 'Patient Date Of Birth',
                        column: 'dateOfBirth',
                        type: 'date',
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'patientId'
                    },
                    {
                        from: 'name',
                        to: 'patientName'
                    },
                    {
                        from: 'address',
                        to: 'patientAddress'
                    },
                    {
                        from: 'patientAge',
                        to: 'patientAge'
                    }
                ]
            },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const patientOrthoDiagnoseApi = api('patient-ortho-diagnose/detail')
            this.patientOrthoDiagnose = await patientOrthoDiagnoseApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const patientOrthoDiagnoseApi = api('patient-ortho-diagnose')

            if(this.$route.query.id !== undefined) {
                await patientOrthoDiagnoseApi.update(this.patientOrthoDiagnose, this.$route.query.id)
            } else {
                await patientOrthoDiagnoseApi.create(this.patientOrthoDiagnose)
            }
            // this.$router.push({ name: 'patientOrthoDiagnose' })
            this.$router.go(-1)
        },
        cancel() {
            // this.$router.push({ name: 'patientOrthoDiagnose' })
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentPatientOrthoDiagnose = this.patientOrthoDiagnose
            this.patientOrthoDiagnose = {
                ...currentPatientOrthoDiagnose,
                ...data
            }
        },
        selectChange(data) {
            const currentPatientOrthoDiagnose = this.patientOrthoDiagnose
            this.patientOrthoDiagnose = {
                ...currentPatientOrthoDiagnose,
                ...data
            }
        },
    }
}
</script>